(function () {
  const RANGE_FIELD_CONFIG = [
    { key: 'lange_mm', label: 'Länge (mm)', format: 'number', unit: 'mm', allowZero: false },
    { key: 'breite_mm', label: 'Breite (mm)', format: 'number', unit: 'mm', allowZero: false },
    { key: 'hoehe_mm', label: 'Höhe (mm)', format: 'number', unit: 'mm', allowZero: false },
    { key: 'inventory', label: 'Lagerbestand', format: 'number', unit: 'Stück', allowZero: true },
    { key: 'price', label: 'Preis', format: 'money', unit: '€', allowZero: false }
  ];

  const SELECT_FIELDS = [
    { key: 'wellenzahl', label: 'Wellenzahl' },
    { key: 'fefco', label: 'FEFCO Code' },
    { key: 'bedruckung', label: 'Bedruckung' },
    { key: 'qualitat', label: 'Qualität' },
    { key: 'farbe', label: 'Farbe' },
    { key: 'hersteller', label: 'Hersteller' }
  ];

  /* Anzeige-Reihenfolge: Maße → Wellenzahl → Bestand → Preis → weitere Attribute */
  const FILTER_ORDER = [
    { type: 'range', key: 'lange_mm' },
    { type: 'range', key: 'breite_mm' },
    { type: 'range', key: 'hoehe_mm' },
    { type: 'select', key: 'wellenzahl' },
    { type: 'range', key: 'inventory' },
    { type: 'range', key: 'price' },
    { type: 'select', key: 'fefco' },
    { type: 'select', key: 'bedruckung' },
    { type: 'select', key: 'qualitat' },
    { type: 'select', key: 'farbe' },
    { type: 'select', key: 'hersteller' }
  ];

  const RANGE_BY_KEY = Object.fromEntries(RANGE_FIELD_CONFIG.map((config) => [config.key, config]));
  const SELECT_BY_KEY = Object.fromEntries(SELECT_FIELDS.map((config) => [config.key, config]));

  class KspMetafieldFilters {
    constructor(root) {
      this.root = root;
      this.collectionHandle = root.dataset.collectionHandle;
      this.childHandles = (root.dataset.childHandles || '')
        .split(',')
        .map((handle) => handle.trim())
        .filter(Boolean)
        .filter((handle) => handle !== this.collectionHandle);
      this.loadAll = root.dataset.loadAll !== 'false';
      this.products = [];
      this.collectionMeta = {};
      this.filters = {};
      this.ranges = {};
      this.rangeConfigByKey = RANGE_BY_KEY;
      this.initFilterState();
      this.init();
    }

    initFilterState() {
      RANGE_FIELD_CONFIG.forEach((config) => {
        this.filters[config.key] = { min: null, max: null };
      });
      SELECT_FIELDS.forEach(({ key }) => {
        this.filters[key] = '';
      });
    }

    async init() {
      try {
        this.cacheElements();
        this.bindEvents();

        const booted = this.bootFromInline();
        if (booted) {
          try {
            this.buildFilters();
          } catch (error) {
            console.error('KSP Filter: buildFilters fehlgeschlagen', error);
            try {
              sessionStorage.removeItem(this.cacheKey());
              sessionStorage.removeItem(`ksp-filter-v2:${this.collectionHandle}`);
              sessionStorage.removeItem(`ksp-filter-products:${this.collectionHandle}`);
            } catch (e) {}
            // Nochmal mit Inline-Daten
            const inline = this.readInlineScript();
            if (inline) {
              this.products = inline;
              this.buildFilters();
            }
          }
          this.applyFilters();
        } else if (this.countEl) {
          this.countEl.textContent = 'Lädt…';
        }

        this.loadParentInBackground(Boolean(this.products.length)).catch((error) => {
          console.error('KSP Filter: Hintergrundladen fehlgeschlagen', error);
          if (!this.products.length && this.countEl) {
            this.countEl.textContent = 'Filter nicht verfügbar';
          } else if (this.products.length) {
            this.applyFilters();
          }
        });
      } catch (error) {
        console.error('KSP Filter: Init fehlgeschlagen', error);
        if (this.countEl) this.countEl.textContent = 'Filter nicht verfügbar';
      }
    }

    cacheElements() {
      this.sidebar = this.root.querySelector('[data-ksp-filters-sidebar]');
      this.drawer = this.root.querySelector('[data-ksp-filters-drawer]');
      this.drawerOverlay = this.root.querySelector('[data-ksp-filters-overlay]');
      this.mobileTrigger = this.root.querySelector('[data-ksp-filters-mobile-trigger]');
      this.activeContainer = this.root.querySelector('[data-ksp-filters-active]');
      this.resetBtn = this.root.querySelector('[data-ksp-filters-reset]');
      this.countEl = this.root.querySelector('[data-ksp-filters-count]');
      this.fieldsContainer =
        this.root.querySelector('[data-ksp-filters-fields]') ||
        this.root.querySelector('[data-ksp-filters-ranges]');
      this.rangeContainer = this.fieldsContainer;
      this.selectContainer = this.fieldsContainer;
      this.resultCountEl = this.root.querySelector('[data-ksp-filters-result-count]');
      this.productGrid = document.getElementById('product-grid');
      if (this.productGrid) {
        this.productGrid.closest('.collection')?.classList.add('collection--ksp-filtered');
      }
    }

    bindEvents() {
      this.mobileTrigger?.addEventListener('click', () => this.openDrawer());
      this.drawerOverlay?.addEventListener('click', () => this.closeDrawer());
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.drawer?.classList.contains('is-open')) {
          this.closeDrawer();
        }
      });
      this.root.addEventListener('click', (e) => {
        if (e.target.closest('[data-ksp-filters-reset]')) this.resetFilters();
        if (e.target.closest('[data-ksp-filters-close]')) this.closeDrawer();
        const pill = e.target.closest('.ksp-filters__pill');
        if (pill && e.target.closest('button')) {
          const field = pill.dataset.pillField;
          if (pill.dataset.pillType === 'range') {
            const { min, max } = this.ranges[field];
            this.filters[field] = { min, max };
            this.syncRangeInputs(field, min, max);
            this.updateRangeFill(field, min, max);
          } else {
            this.filters[field] = '';
            this.syncSelects(field, '');
          }
          this.applyFilters();
        }
      });
      this.root.addEventListener('change', (e) => {
        const select = e.target.closest('[data-select-filter]');
        if (select) {
          this.filters[select.dataset.selectFilter] = select.value;
          this.syncSelects(select.dataset.selectFilter, select.value);
          this.applyFilters();
        }
        const minInput = e.target.closest('[data-range-min]');
        const maxInput = e.target.closest('[data-range-max]');
        if (minInput) this.syncRange(minInput.dataset.rangeMin, 'min');
        if (maxInput) this.syncRange(maxInput.dataset.rangeMax, 'max');
        const minSlider = e.target.closest('[data-range-min-slider]');
        const maxSlider = e.target.closest('[data-range-max-slider]');
        if (minSlider) this.syncRange(minSlider.dataset.rangeMinSlider, 'min');
        if (maxSlider) this.syncRange(maxSlider.dataset.rangeMaxSlider, 'max');
      });
      this.root.addEventListener('input', (e) => {
        const minSlider = e.target.closest('[data-range-min-slider]');
        const maxSlider = e.target.closest('[data-range-max-slider]');
        if (minSlider) {
          const field = minSlider.dataset.rangeMinSlider;
          this.setRangeInputValue(field, 'min', Number(minSlider.value));
          this.syncRange(field, 'min', true);
          return;
        }
        if (maxSlider) {
          const field = maxSlider.dataset.rangeMaxSlider;
          this.setRangeInputValue(field, 'max', Number(maxSlider.value));
          this.syncRange(field, 'max', true);
          return;
        }
        // Zahlenfelder live mitziehen (nicht erst bei blur/change)
        const minInput = e.target.closest('[data-range-min]');
        const maxInput = e.target.closest('[data-range-max]');
        if (minInput) this.syncRange(minInput.dataset.rangeMin, 'min');
        if (maxInput) this.syncRange(maxInput.dataset.rangeMax, 'max');
      });
    }

    readInlineScript() {
      const inlineId = `KspCollectionProducts-${this.root.dataset.sectionId}`;
      const scriptEl = document.getElementById(inlineId);
      if (!scriptEl) return null;
      try {
        const parsed = JSON.parse(scriptEl.textContent);
        return Array.isArray(parsed) && parsed.length ? parsed : null;
      } catch (error) {
        console.error('KSP Filter: Inline-Daten ungültig', error);
        return null;
      }
    }

    bootFromInline() {
      // Immer zuerst die Daten von der Seite – Cache war oft kaputt/aufgebläht
      const fromDom = this.readInlineScript();
      if (fromDom) {
        this.products = fromDom;
        return true;
      }

      const cached = this.readCache();
      if (cached?.length) {
        this.products = cached;
        return true;
      }

      return false;
    }

    cacheKey() {
      return `ksp-filter-v3:${this.collectionHandle}`;
    }

    readCache() {
      try {
        const raw = sessionStorage.getItem(this.cacheKey());
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        if (!parsed?.expires || parsed.expires < Date.now()) {
          sessionStorage.removeItem(this.cacheKey());
          return null;
        }
        return Array.isArray(parsed.products) ? parsed.products : null;
      } catch (error) {
        return null;
      }
    }

    writeCache(products) {
      try {
        sessionStorage.setItem(
          this.cacheKey(),
          JSON.stringify({
            expires: Date.now() + 15 * 60 * 1000,
            products,
          })
        );
      } catch (error) {
        // optional
      }
    }

    rebuildFiltersPreservingState() {
      if (!this.fieldsContainer) return;
      const previous = {
        ranges: { ...this.filters },
        selects: Object.fromEntries(SELECT_FIELDS.map(({ key }) => [key, this.filters[key]])),
      };
      this.fieldsContainer.innerHTML = '';
      this.ranges = {};
      this.buildFilters();
      RANGE_FIELD_CONFIG.forEach((config) => {
        const field = config.key;
        if (!this.ranges[field] || !previous.ranges[field]) return;
        const { min: rMin, max: rMax } = this.ranges[field];
        let lo = previous.ranges[field].min;
        let hi = previous.ranges[field].max;
        if (lo == null || hi == null) return;
        lo = Math.max(rMin, Math.min(rMax, lo));
        hi = Math.max(rMin, Math.min(rMax, hi));
        this.filters[field] = { min: lo, max: hi };
        this.syncRangeInputs(field, lo, hi);
        this.updateRangeFill(field, rMin, rMax);
      });
      SELECT_FIELDS.forEach(({ key }) => {
        const value = previous.selects[key] || '';
        this.filters[key] = value;
        this.syncSelects(key, value);
      });
    }

    async loadParentInBackground(alreadyBooted) {
      if (!alreadyBooted && this.countEl) this.countEl.textContent = 'Lädt…';

      const parentProducts = await this.fetchAllCollectionProducts(this.collectionHandle);
      const next = parentProducts.filter((product) => product?.handle);
      // Nie eine funktionierende Inline-Liste mit leerem Fetch überschreiben
      if (!next.length) {
        if (!alreadyBooted && this.countEl) {
          this.countEl.textContent = 'Filter nicht verfügbar';
        }
        return;
      }

      this.products = next;
      this.writeCache(this.products);

      // Nur Nutzer-Filter behalten – sonst wirken alte Min/Max wie aktiv
      if (alreadyBooted && this.hasActiveFilters()) {
        this.rebuildFiltersPreservingState();
      } else {
        this.buildFilters();
      }
      this.applyFilters();
    }

    parseProductsPayload(payload) {
      if (Array.isArray(payload)) {
        return { products: payload, page: 1, pages: 1, products_count: payload.length };
      }
      if (payload && Array.isArray(payload.products)) {
        return {
          products: payload.products,
          page: Number(payload.page) || 1,
          pages: Math.max(1, Number(payload.pages) || 1),
          products_count: Number(payload.products_count) || payload.products.length,
        };
      }
      return { products: [], page: 1, pages: 1, products_count: 0 };
    }

    async fetchWithTimeout(url, ms = 10000) {
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), ms);
      try {
        const response = await fetch(url, { signal: controller.signal });
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        return response;
      } finally {
        clearTimeout(timer);
      }
    }

    async fetchCollectionPage(handle, page) {
      const url = `/collections/${encodeURIComponent(handle)}?view=metafield-json&page=${page}`;
      const response = await this.fetchWithTimeout(url, 10000);
      return this.parseProductsPayload(await response.json());
    }

    async fetchAllCollectionProducts(handle) {
      const first = await this.fetchCollectionPage(handle, 1);
      const products = [...first.products];
      const pages = Math.min(first.pages || 1, 10);
      this.collectionMeta[handle] = {
        pages: first.pages,
        products_count: first.products_count,
      };

      if (pages > 1) {
        const rest = await Promise.all(
          Array.from({ length: pages - 1 }, (_, index) => this.fetchCollectionPage(handle, index + 2))
        );
        rest.forEach((pageData) => {
          products.push(...pageData.products);
        });
      }

      return products;
    }

    async fetchProductCardsPage(handle, page) {
      const url = `/collections/${encodeURIComponent(handle)}?view=product-cards&page=${page}`;
      const response = await this.fetchWithTimeout(url, 12000);
      return response.text();
    }

    appendCardsFromHtml(html, missing) {
      if (!html.trim() || !this.productGrid) return { appended: 0, received: 0 };
      const temp = document.createElement('ul');
      temp.innerHTML = html;
      const items = Array.from(temp.querySelectorAll('.grid__item[data-product-handle]'));
      let appended = 0;
      items.forEach((item) => {
        const productHandle = item.dataset.productHandle;
        if (!missing.has(productHandle)) return;
        if (this.productGrid.querySelector(`[data-product-handle="${CSS.escape(productHandle)}"]`)) {
          missing.delete(productHandle);
          return;
        }
        this.productGrid.appendChild(item);
        missing.delete(productHandle);
        appended += 1;
      });
      return { appended, received: items.length };
    }

    async ensureProductCards() {
      if (!this.productGrid || !this.products.length || this._cardsLoading) return;
      this._cardsLoading = true;

      try {
        const existing = new Set(
          Array.from(this.productGrid.querySelectorAll('[data-product-handle]')).map(
            (el) => el.dataset.productHandle
          )
        );
        const missing = new Set(
          this.products.map((product) => product.handle).filter((handle) => handle && !existing.has(handle))
        );
        if (!missing.size) return;

        const handle = this.collectionHandle;
        const total = this.collectionMeta[handle]?.products_count || this.products.length;
        const cardPages = Math.max(1, Math.ceil(total / 250));

        for (let page = 1; page <= cardPages; page += 1) {
          if (!missing.size) break;
          try {
            const html = await this.fetchProductCardsPage(handle, page);
            this.appendCardsFromHtml(html, missing);
            this.applyFilters();
            // Browser kurz atmen lassen
            await new Promise((resolve) => setTimeout(resolve, 0));
          } catch (error) {
            console.error('KSP Filter: Produktkarten nachladen fehlgeschlagen', handle, page, error);
            break;
          }
        }
      } finally {
        this._cardsLoading = false;
      }
    }

    isMobileViewport() {
      return window.matchMedia('(max-width: 989px)').matches;
    }

    formatEuro(cents) {
      return new Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: 'EUR',
      }).format(cents / 100);
    }

    displayValue(config, value) {
      if (config.format === 'money') {
        return (value / 100).toFixed(2);
      }
      return value;
    }

    parseInputValue(config, raw) {
      const num = Number(raw);
      if (Number.isNaN(num)) return null;
      if (config.format === 'money') return Math.round(num * 100);
      return Math.round(num);
    }

    formatRangeLabel(config, min, max) {
      if (config.format === 'money') {
        return `${this.formatEuro(min)} – ${this.formatEuro(max)}`;
      }
      return `${min} – ${max} ${config.unit}`;
    }

    formatPillLabel(config, min, max) {
      if (config.format === 'money') {
        return `${config.label}: ${this.formatEuro(min)} – ${this.formatEuro(max)}`;
      }
      return `${config.label}: ${min}–${max} ${config.unit}`;
    }

    getRangeValues(config) {
      const values = [];
      for (let i = 0; i < this.products.length; i += 1) {
        const raw = this.products[i][config.key];
        if (raw === null || raw === undefined || raw === '') continue;
        const value = Number(raw);
        if (Number.isNaN(value)) continue;
        if (config.allowZero) {
          if (value >= 0) values.push(value);
        } else if (value > 0) {
          values.push(value);
        }
      }
      return values;
    }

    minMax(values) {
      let min = values[0];
      let max = values[0];
      for (let i = 1; i < values.length; i += 1) {
        const value = values[i];
        if (value < min) min = value;
        if (value > max) max = value;
      }
      return { min, max };
    }

    createFilterGroup(title, contentHtml, openByDefault = false) {
      const group = document.createElement('details');
      group.className = 'ksp-filters__group';
      if (openByDefault || !this.isMobileViewport()) {
        group.setAttribute('open', '');
      }
      group.innerHTML = `
        <summary class="ksp-filters__group-title">${title}</summary>
        <div class="ksp-filters__group-body">${contentHtml}</div>
      `;
      return group;
    }

    buildFilters() {
      if (!this.fieldsContainer) return;
      this.fieldsContainer.innerHTML = '';

      let groupIndex = 0;
      FILTER_ORDER.forEach((entry) => {
        let group = null;
        if (entry.type === 'range') {
          group = this.createRangeFilterGroup(RANGE_BY_KEY[entry.key], groupIndex);
        } else if (entry.type === 'select') {
          group = this.createSelectFilterGroup(SELECT_BY_KEY[entry.key], groupIndex);
        }
        if (group) {
          this.fieldsContainer.appendChild(group);
          groupIndex += 1;
        }
      });
    }

    createRangeFilterGroup(config, groupIndex) {
      if (!config) return null;

      const values = this.getRangeValues(config);
      if (!values.length) return null;

      const { min, max } = this.minMax(values);
      const field = config.key;
      this.ranges[field] = { min, max };
      this.filters[field] = { min, max };

      const inputStep = config.format === 'money' ? '0.01' : '1';
      const minDisplay = this.displayValue(config, min);
      const maxDisplay = this.displayValue(config, max);
      const minAttr = config.format === 'money' ? this.displayValue(config, min) : min;
      const maxAttr = config.format === 'money' ? this.displayValue(config, max) : max;

      const group = this.createFilterGroup(
        config.label,
        `
          <div class="ksp-filters__range-inputs">
            <div>
              <label>Min</label>
              <input type="number" step="${inputStep}" data-range-min="${field}" value="${minDisplay}" min="${minAttr}" max="${maxAttr}">
            </div>
            <div>
              <label>Max</label>
              <input type="number" step="${inputStep}" data-range-max="${field}" value="${maxDisplay}" min="${minAttr}" max="${maxAttr}">
            </div>
          </div>
          <div class="ksp-filters__slider-wrap" data-range-slider="${field}">
            <div class="ksp-filters__slider-rail" aria-hidden="true">
              <div class="ksp-filters__slider-range" data-range-fill="${field}"></div>
            </div>
            <input type="range" class="ksp-filters__slider ksp-filters__slider--min" data-range-min-slider="${field}" min="${min}" max="${max}" value="${min}" aria-label="${config.label} Minimum">
            <input type="range" class="ksp-filters__slider ksp-filters__slider--max" data-range-max-slider="${field}" min="${min}" max="${max}" value="${max}" aria-label="${config.label} Maximum">
          </div>
          <div class="ksp-filters__range-label" data-range-label="${field}">${this.formatRangeLabel(config, min, max)}</div>
        `,
        groupIndex === 0
      );
      this.updateRangeFill(field, min, max);
      return group;
    }

    createSelectFilterGroup(config, groupIndex) {
      if (!config) return null;

      const { key, label } = config;
      const values = [...new Set(this.products.map((p) => p[key]).filter(Boolean))].sort();
      if (!values.length) return null;

      return this.createFilterGroup(
        label,
        `
          <select class="ksp-filters__select" data-select-filter="${key}">
            <option value="">Alle</option>
            ${values.map((v) => `<option value="${this.escapeHtml(v)}">${this.escapeHtml(v)}</option>`).join('')}
          </select>
        `,
        groupIndex === 0
      );
    }

    escapeHtml(str) {
      const div = document.createElement('div');
      div.textContent = str;
      return div.innerHTML;
    }

    setRangeInputValue(field, type, value) {
      const config = this.rangeConfigByKey[field];
      const display = config ? this.displayValue(config, value) : value;
      const selector = type === 'min' ? `[data-range-min="${field}"]` : `[data-range-max="${field}"]`;
      this.root.querySelectorAll(selector).forEach((el) => {
        el.value = display;
      });
      const sliderSelector =
        type === 'min' ? `[data-range-min-slider="${field}"]` : `[data-range-max-slider="${field}"]`;
      this.root.querySelectorAll(sliderSelector).forEach((el) => {
        el.value = value;
      });
    }

    syncRangeInputs(field, min, max) {
      this.setRangeInputValue(field, 'min', min);
      this.setRangeInputValue(field, 'max', max);
    }

    syncRange(field, source, applyNow = true) {
      const config = this.rangeConfigByKey[field];
      const { min, max } = this.ranges[field];
      const minInput = this.root.querySelector(`[data-range-min="${field}"]`);
      const maxInput = this.root.querySelector(`[data-range-max="${field}"]`);
      let lo = this.parseInputValue(config, minInput?.value);
      let hi = this.parseInputValue(config, maxInput?.value);
      if (lo === null || hi === null) return;
      if (lo > hi) {
        if (source === 'min') hi = lo;
        else lo = hi;
      }
      lo = Math.max(min, Math.min(max, lo));
      hi = Math.max(min, Math.min(max, hi));
      this.filters[field] = { min: lo, max: hi };
      this.syncRangeInputs(field, lo, hi);
      this.updateRangeFill(field, min, max);
      if (applyNow) this.applyFilters();
    }

    updateRangeFill(field, min, max) {
      const config = this.rangeConfigByKey[field];
      const lo = Number(this.filters[field].min);
      const hi = Number(this.filters[field].max);
      const range = max - min || 1;
      const left = ((lo - min) / range) * 100;
      const width = ((hi - lo) / range) * 100;
      this.root.querySelectorAll(`[data-range-fill="${field}"]`).forEach((fill) => {
        fill.style.left = `${left}%`;
        fill.style.width = `${width}%`;
      });
      this.root.querySelectorAll(`[data-range-label="${field}"]`).forEach((label) => {
        label.textContent = this.formatRangeLabel(config, lo, hi);
      });
    }

    syncSelects(key, value) {
      this.root.querySelectorAll(`[data-select-filter="${key}"]`).forEach((select) => {
        select.value = value;
      });
    }

    matchesRange(product, config) {
      if (!this.ranges[config.key]) return true;
      const { min, max } = this.filters[config.key];
      const { min: rMin, max: rMax } = this.ranges[config.key];
      if (min === rMin && max === rMax) return true;

      const value = product[config.key];
      if (value === null || value === undefined) return false;

      const val = Number(value);
      if (Number.isNaN(val)) return false;
      if (!config.allowZero && val <= 0) return false;
      if (config.allowZero && val < 0) return false;
      return val >= min && val <= max;
    }

    getVisibleHandles() {
      return this.products
        .filter((product) => {
          for (const config of RANGE_FIELD_CONFIG) {
            if (!this.matchesRange(product, config)) return false;
          }
          for (const { key } of SELECT_FIELDS) {
            if (this.filters[key] && product[key] !== this.filters[key]) return false;
          }
          return true;
        })
        .map((p) => p.handle);
    }

    applyFilters() {
      const visible = new Set(this.getVisibleHandles());
      const hasActive = this.hasActiveFilters();
      const scrollY = window.scrollY;

      if (hasActive && !this._cardsLoading) {
        this.ensureProductCards().catch((error) => {
          console.error('KSP Filter: Karten-Nachladen fehlgeschlagen', error);
        });
      }

      if (this.productGrid) {
        let visibleOnPage = 0;
        this.productGrid.querySelectorAll('.grid__item[data-product-handle]').forEach((item) => {
          const handle = item.dataset.productHandle;
          const show = !hasActive || visible.has(handle);
          item.classList.toggle('is-filter-hidden', !show);
          if (show) visibleOnPage += 1;
        });
        const emptyMsg = document.querySelector('[data-ksp-filters-empty]');
        if (emptyMsg) {
          emptyMsg.classList.toggle('is-visible', visibleOnPage === 0 && hasActive);
        }
      }

      this.updateActivePills();
      this.root.querySelectorAll('[data-ksp-filters-reset]').forEach((btn) => {
        btn.classList.toggle('is-visible', hasActive);
      });
      this.root.classList.toggle('has-active-filters', hasActive);
      this.updateDrawerResultCount(visible.size);
      if (this.countEl) {
        this.countEl.textContent = hasActive
          ? `${visible.size} von ${this.products.length} Produkten`
          : `${this.products.length} Produkte`;
      }

      requestAnimationFrame(() => {
        window.scrollTo(0, scrollY);
      });
    }

    hasActiveFilters() {
      for (const config of RANGE_FIELD_CONFIG) {
        if (!this.ranges[config.key]) continue;
        const { min, max } = this.filters[config.key];
        const { min: rMin, max: rMax } = this.ranges[config.key];
        if (min !== rMin || max !== rMax) return true;
      }
      return SELECT_FIELDS.some(({ key }) => this.filters[key]);
    }

    updateActivePills() {
      const containers = this.root.querySelectorAll('[data-ksp-filters-active]');
      if (!containers.length) return;
      containers.forEach((c) => {
        c.innerHTML = '';
      });
      const pills = [];

      RANGE_FIELD_CONFIG.forEach((config) => {
        if (!this.ranges[config.key]) return;
        const { min, max } = this.filters[config.key];
        const { min: rMin, max: rMax } = this.ranges[config.key];
        if (min !== rMin || max !== rMax) {
          pills.push({
            type: 'range',
            field: config.key,
            label: this.formatPillLabel(config, min, max),
          });
        }
      });

      SELECT_FIELDS.forEach(({ key, label }) => {
        if (this.filters[key]) {
          pills.push({ type: 'select', field: key, label: `${label}: ${this.filters[key]}` });
        }
      });

      pills.forEach((pill) => {
        const el = document.createElement('span');
        el.className = 'ksp-filters__pill';
        el.dataset.pillType = pill.type;
        el.dataset.pillField = pill.field;
        el.innerHTML = `${pill.label} <button type="button" aria-label="Entfernen">&times;</button>`;
        containers[0].appendChild(el);
      });

      containers.forEach((c) => {
        c.classList.toggle('is-visible', pills.length > 0);
      });
    }

    resetFilters() {
      RANGE_FIELD_CONFIG.forEach((config) => {
        if (!this.ranges[config.key]) return;
        const { min, max } = this.ranges[config.key];
        this.filters[config.key] = { min, max };
        this.syncRangeInputs(config.key, min, max);
        this.updateRangeFill(config.key, min, max);
      });
      SELECT_FIELDS.forEach(({ key }) => {
        this.filters[key] = '';
        this.syncSelects(key, '');
      });
      this.applyFilters();
    }

    updateDrawerResultCount(visibleCount) {
      if (!this.resultCountEl) return;
      const count = typeof visibleCount === 'number' ? visibleCount : this.getVisibleHandles().length;
      const hasActive = this.hasActiveFilters();
      this.resultCountEl.textContent = hasActive ? `(${count})` : `(${this.products.length})`;
    }

    openDrawer() {
      const body = this.drawer?.querySelector('[data-ksp-filters-drawer-body]');
      if (body && this.sidebar) {
        body.innerHTML = '';

        const active = this.activeContainer?.cloneNode(true);
        if (active) {
          active.classList.toggle('is-visible', this.hasActiveFilters());
          body.appendChild(active);
        }

        const fields = this.fieldsContainer?.cloneNode(true);
        if (fields) body.appendChild(fields);

        body.querySelectorAll('.ksp-filters__group').forEach((group, index) => {
          const field = group.querySelector('[data-range-min], [data-select-filter]');
          const rangeField = field?.dataset.rangeMin || field?.dataset.selectFilter;
          const isActive =
            (rangeField &&
              this.ranges[rangeField] &&
              (this.filters[rangeField].min !== this.ranges[rangeField].min ||
                this.filters[rangeField].max !== this.ranges[rangeField].max)) ||
            (field?.dataset.selectFilter && this.filters[field.dataset.selectFilter]);

          if (isActive) {
            group.setAttribute('open', '');
          } else if (index > 0) {
            group.removeAttribute('open');
          }
        });
      }

      this.drawer?.classList.add('is-open');
      this.drawerOverlay?.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      this.updateDrawerResultCount();
    }

    closeDrawer() {
      this.drawer?.classList.remove('is-open');
      this.drawerOverlay?.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  }

  function startKspMetafieldFilters() {
    document.querySelectorAll('[data-ksp-metafield-filters]').forEach((root) => {
      if (root.dataset.kspFiltersReady === 'true') return;
      root.dataset.kspFiltersReady = 'true';
      new KspMetafieldFilters(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startKspMetafieldFilters);
  } else {
    startKspMetafieldFilters();
  }
})();
